// test1889
(1889 && 0);
